
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import './StateDisclosure.scss';

const stateLicenseData = [
    { state: 'AL', license: '0783259' },
    { state: 'AK', license: '100141923' },
    { state: 'AZ', license: '1175591' },
    { state: 'AR', license: '3000074001' },
    { state: 'CA', license: '0L77229' },
    { state: 'CO', license: '532851' },
    { state: 'CT', license: '2551636' },
    { state: 'DC', license: '3000073987' },
    { state: 'DE', license: '3000067942' },
    { state: 'FL', license: 'L099678' },
    { state: 'GA', license: '194472' },
    { state: 'HI', license: '451231' },
    { state: 'ID', license: '607086' },
    { state: 'IL', license: '3000078371' },
    { state: 'IN', license: '3225101' },
    { state: 'IA', license: '1002287899' },
    { state: 'KS', license: '813686767-000' },
    { state: 'KY', license: '948084' },
    { state: 'LA', license: '724500' },
    { state: 'ME', license: 'AGN283495' },
    { state: 'MD', license: '3000073999' },
    { state: 'MA', license: '2027441' },
    { state: 'MI', license: '0112074' },
    { state: 'MN', license: '40514835' },
    { state: 'MS', license: '15031165' },
    { state: 'MO', license: '8409226' },
    { state: 'MT', license: '3000073992' },
    { state: 'NE', license: '100264901' },
    { state: 'NV', license: '3225020' },
    { state: 'NH', license: '2364248' },
    { state: 'NJ', license: '1635336' },
    { state: 'NM', license: '100015168' },
    { state: 'NY', license: '1475074' },
    { state: 'NC', license: '1000517981' },
    { state: 'ND', license: '3000073983' },
    { state: 'OH', license: '1140517' },
    { state: 'OK', license: '100287002' },
    { state: 'OR', license: '3000087663' },
    { state: 'PA', license: '805968' },
    { state: 'RI', license: '3000081962' },
    { state: 'SC', license: '211633' },
    { state: 'SD', license: '1019526' },
    { state: 'TN', license: '2359992' },
    { state: 'TX', license: '2188156' },
    { state: 'UT', license: '608655' },
    { state: 'VT', license: '3231259' },
    { state: 'VA', license: '141432' },
    { state: 'WA', license: '945321' },
    { state: 'WV', license: '100239073' },
    { state: 'WI', license: '3000073996' },
    { state: 'WY', license: '333377' },
];

export default function StateDisclosure() {
    const tableStyle = { border: '1px solid rgba(224, 224, 224, 1)' };
    const tableMainHeadStyle = { backgroundColor: '#7E7E7E', color: 'white', textAlign: 'center' as const };
    const tableHeadStyle = { border: '1px solid rgba(224, 224, 224, 1)', textAlign: 'center' as const };

    return (
        <div className="state-disclosure">
            <TableContainer>
                <Table style={tableStyle} aria-label="State License Disclosure">
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ ...tableHeadStyle, ...tableMainHeadStyle }} colSpan={1}>State</TableCell>
                            <TableCell style={{ ...tableHeadStyle, ...tableMainHeadStyle }} colSpan={1}>License #</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {stateLicenseData.map((row) => (
                            <TableRow key={row.state}>
                                <TableCell style={tableHeadStyle} component="th" scope="row">{row.state}</TableCell>
                                <TableCell style={tableHeadStyle} component="th" scope="row">{row.license}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}
